import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

export const useQRCode = ({ address }: { address?: string }) => {
	const [qrCode, setQrCode] = useState('');

	useEffect(() => {
		if (!address) return;

		QRCode.toDataURL(address).then(setQrCode).catch(console.error);
	}, [address]);

	return {
		qrCode,
		setQrCode,
	};
};
